/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the Tocsoft.GraphQLCodeGen toolchain https://github.com/tocsoft/GraphQLCodeGen
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {HttpClient} from 'aurelia-fetch-client';
import {inject} from 'aurelia-framework';
import { apiUrl } from '../../constants'

interface fetchClient {
    fetch(url: RequestInfo, init: RequestInit): Promise<Response>
}

class GraphQLResponse
{
    data: any
    errors: Array<{ message: string }>
}

function RemoveCollectionEntityError(message:string, httpResponse:Response, graphqlResponse?: GraphQLResponse) {
    this.name = 'RemoveCollectionEntityError';
    this.message = message || 'Error fetching graphql response';
    this.stack = (new Error()).stack;
    this.httpResponse = httpResponse;
    if(graphqlResponse && graphqlResponse.errors){
        this.errors = graphqlResponse.errors.map(x=>x.message);
    }
  }
  RemoveCollectionEntityError.prototype = Object.create(Error.prototype);
  RemoveCollectionEntityError.prototype.constructor = RemoveCollectionEntityError;
  
export { RemoveCollectionEntityError }

@inject(HttpClient, apiUrl)
export class RemoveCollectionEntityClient {

    constructor(public client: fetchClient, public url: string) { }
	
	removeCollectionEntity_removeCollectionEntity(	update? :RemoveCollectionEntityRequestInput) : Promise<RemoveCollectionEntityRemoveCollectionEntityResult>{
        return this.client.fetch(this.url, {
            method : 'POST',
            body : JSON.stringify({
                query : `mutation removeCollectionEntity($update: RemoveCollectionEntityRequestInput) {
  removeCollectionEntity(request: $update) {
    success
    isLocked
  }
}
`,
                variables : {
					update : update ,
                }
            })
        }).then(response=>{
            if(response.status != 200){
                // error result
                throw new RemoveCollectionEntityError("http error running 'removeCollectionEntity_removeCollectionEntity', see httpResponse for more details.", response)
            }else{
                return response.json().then((json:GraphQLResponse)=>{
                    
                    if(json.errors && json.errors.length > 0){
                        throw new RemoveCollectionEntityError("graphql error(s) running 'removeCollectionEntity_removeCollectionEntity', see errors collection fro more details", response, json)
                    }

                    const result: any = RemoveCollectionEntityRemoveCollectionEntityResult.fromJS(json.data);                
                    
                    return result;
                })
            }
        })
    }	
}

export class RemoveCollectionEntityRequestInput {
		id? :string;
		ownerId? :string;
		fieldName? :string;
		collectionEntityId? :string;

    static fromJS(json:any):RemoveCollectionEntityRequestInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new RemoveCollectionEntityRequestInput();

	result.id = json["id"];
	result.ownerId = json["ownerId"];
	result.fieldName = json["fieldName"];
	result.collectionEntityId = json["collectionEntityId"];

        return result;
    }
}

export class RemoveCollectionEntityRemoveCollectionEntityResult {
		removeCollectionEntity? :SuccessResultResult;

    static fromJS(json:any):RemoveCollectionEntityRemoveCollectionEntityResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new RemoveCollectionEntityRemoveCollectionEntityResult();

result.removeCollectionEntity= SuccessResultResult.fromJS(json["removeCollectionEntity"]);

        return result;
    }
}

export class SuccessResultResult {
		success :boolean;
		isLocked :boolean;

    static fromJS(json:any):SuccessResultResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new SuccessResultResult();

	result.success = json["success"];
	result.isLocked = json["isLocked"];

        return result;
    }
}


